import { Configuration, LogLevel } from "@azure/msal-browser";
import { devConsole } from './utils/devConsole';

// Debug: Log environment variables for development debugging
devConsole.log('AuthConfig — CLIENT_ID:', process.env.REACT_APP_CLIENT_ID);
devConsole.log('AuthConfig — NODE_ENV:', process.env.NODE_ENV);
devConsole.log('AuthConfig — redirectUri (runtime):', window.location.origin);

// Replace these values with your Azure AD app registration details
// Or set them in .env.local file (copy from .env.example)
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || "YOUR_CLIENT_ID", // Replace with your Application (client) ID
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID || "YOUR_TENANT_ID"}`, // Replace with your tenant ID or use "common" for multi-tenant
    // Always use current origin at runtime — env-based URIs are baked at build time and
    // dev builds can incorrectly pick up .env.production (prod URL) when NODE_ENV=production.
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set to true if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
    },
  },
};

const apiScope = process.env.REACT_APP_API_SCOPE;

// loginRequest uses Graph scopes only. Azure AD issues tokens per-resource and
// mixing the backend API scope here (a different resource) causes AADSTS650057.
// The backend token is acquired separately via acquireTokenSilent(apiTokenRequest).
export const loginRequest = {
  scopes: ["User.Read", "openid", "profile"],
  redirectUri: window.location.origin,
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphMePhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value"
};

// Request scopes for acquiring an access token for MS Graph
export const tokenRequest = {
  scopes: ["User.Read"],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};

// Backend API token request -- when REACT_APP_API_SCOPE is set, acquireTokenSilent
// uses this to get an access token scoped to our backend App Registration.
export const apiTokenRequest = apiScope ? { scopes: [apiScope] } : null;
